import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FeatureId } from '../constants/features.constants';
import { StateStoreService } from '../services/state-store/state-store';

/**
 * Redirects deep-links to editor routes when the caller has no read
 * entitlement on any of the route's declared feature ids. Assessment
 * type is unknown at guard time, so `edit-assessment` lists the union
 * of assessment features; per-type gating happens in the component via
 * the action-policy service once the record loads.
 *
 * Readiness is guaranteed by `appReadyMatch` at the route level.
 */
export const editorAccessGuard: CanActivateFn = route => {
  const state = inject(StateStoreService);
  const router = inject(Router);
  const featureIds = (route.data['featureIds'] as readonly FeatureId[] | undefined) ?? [];
  if (featureIds.length === 0) return true;
  return featureIds.some(id => state.canReadFeature(id))
    ? true
    : router.createUrlTree(['/dashboard']);
};
